var _defs, _path, _path2, _path3, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteps04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pick_a_Reward",
    "data-name": "Pick a Reward",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #df4f71;\n        isolation: isolate;\n        opacity: .2;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #df4f71;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-3 {\n        fill: rgba(223, 79, 113, .2);\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.357,31H2.071c-.592,0-1.071-.48-1.071-1.071v-5.357c0-.592.48-1.071,1.071-1.071h4.286v7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.357,31H2.071c-.592,0-1.071-.48-1.071-1.071v-5.357c0-.592.48-1.071,1.071-1.071h4.286"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.929,24.571h4.286l8.973-2.064c1.185-.325,2.409.373,2.733,1.558.052.191.079.388.079.585h0c0,.842-.476,1.613-1.229,1.989l-5.199,2.218-8.571,2.143H6.357v-7.5l3.348-3.348c.604-.602,1.424-.94,2.277-.937h6.696c1.479,0,2.679,1.199,2.679,2.679h0c0,1.479-1.199,2.679-2.679,2.679h-3.75Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16 12.222 20.72 15 19.436 9.815 23.636 6.347 18.124 5.922 16 1 13.876 5.922 8.364 6.347 12.564 9.815 11.28 15 16 12.222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps04);
export default __webpack_public_path__ + "static/media/steps-04.1fb3451b9152cbb84330abe9c6efb3eb.svg";
export { ForwardRef as ReactComponent };